var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoezi-anchor",class:{visible : _vm.$root.edit}},[_c('a',{attrs:{"name":_vm.name,"id":_vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }